<template>
    <f7-page
        name="Subscribe Start"
        no-navbar
    >
        <p class="safe-area-top" />
        <h1 class="Stitle">Say yes</h1>
        <h3 class="Ssubtitle">to better sex</h3>
        <p class="imgContainer">
            <img
                src="../../img/0.4/partners.png"
                class="img"
            >
        </p>
        <template>
            <div class="bordered-around">
                <div class="bordered">
                    <div class="bordered-inner">
                        <f7-block style="padding: 0 0 0px; margin-top: 16px; margin-bottom: 16px">
                            <p><b>Free for you, thanks to your partner</b></p>
                            <div class="arguments">
                                <i class="icon ion-ios-checkmark" /> <br>Unlimited access to personalized content<br style="clear: both">
                                <i class="icon ion-ios-checkmark" /> <br>Hundreds of stories, exercises and lessons<br style="clear: both">
                                <i class="icon ion-ios-checkmark" /> <br>New content added weekly
                            </div>
                            <f7-button
                                :animate="false"
                                style="clear: both; margin-top: 30px"
                                color="red"
                                fill
                                large
                                round
                                href="/home"
                            >GET STARTED</f7-button>

                        </f7-block>

                    </div>
                </div>
            </div>
        </template>
        <br>
        <f7-link
            href="/freeViaPartnerTerms"
            class="minorActions safe-area-bottom"
        >PARTNER SUBSCRIPTION DETAILS</f7-link>

    </f7-page>
</template> 

<script>
export default {
    store: ['api', 'user'],
    data () {
        return {
            closeIsBack: true,
            redirectUrl: '/home',
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        },
        getBranch: function () {
            return localStore.getItem('branch') || 'production';
        }
    },
    created: function () {
        if (this.$f7route.query.goToHome) {
            this.closeIsBack = false;
        }
        if (this.$f7route.query.redirect) {
            this.redirectUrl = this.$f7route.query.redirect;
        }
    },
    mounted: function () {

    },
    methods: {

    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';

@media screen and (min-height: 1000px) {
    .longScreenFix {
        margin-top: 20vh;
    }
}

.Stitle {
    padding-top: ~'calc(var(--f7-appbar-app-offset) + 44px)';
    text-align: center;
    margin: 30px 0 0;
    color: @black;
}
.Ssubtitle {
    margin-top: 0px;
    text-align: center;
    font-family: Editor-Bold;
    color: @black;
}
.theme-dark {
    .Stitle {
        color: #fff;
    }
    .Ssubtitle {
        color: #fff;
    }
}
.imgContainer {
    text-align: center;
    margin: 0;
}
.img {
    height: 220px;
}
.arguments {
    max-width: 400px;
    margin: 0 auto;
    text-align: left;
    line-height: 14px;
    font-size: 16px;
    .icon {
        font-size: 40px;
        // color: #1f6500;
        color: #35546e;
        padding-right: 10px;
        float: left;
    }
}
@media only screen and (max-width: 360px) {
    .arguments {
        font-size: 15px;
    }
}
.styleLine {
    border-right: 1px solid @black;
    width: 50vw;
    height: 50px;
    position: absolute;
    bottom: -40px;
}
.minorActions {
    width: 100%;
    font-family: AndesBook;
    text-transform: uppercase;
    font-size: 15px !important;
    color: @black;
    height: 10px;
    text-align: center;
    line-height: 12px;
}
.theme-dark {
    .minorActions {
        color: #fff;
    }
}
.bordered-around {
    margin: 0px auto;
    display: table;
}
.bordered {
    border: 1px solid @black;
    border-radius: 13px;
    display: table;
    margin: 0 20px 0px;
    padding: 0px 20px 0px;
    position: relative;
}
.bordered-inner {
    p {
        font-size: 16px;
    }
    background: white;
    display: inline-block;
    margin: -24px 0px 0px 0;
}
.theme-dark {
    .bordered-inner {
        background: black;
    }
}
</style>
